import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { computed } from "vue";
import type {
  TodoComment,
  TodoCommentListResponse,
} from "@/components/MyStudents/Submissions/components/InternalComments/types";
import { sortCommentsAscending } from "@/components/MyStudents/Submissions/components/InternalComments/utils";
import { hasTodoViewSubmissionPermission } from "@/composables/authorization.js";
import profileService from "@/services/profile.js";

export const TODO_COMMENTS_QUERY_KEY_PREFIX = "todoComments";

export const useTodoComments = (applicationId: Ref<string | undefined>, todoId: Ref<string | undefined>) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [TODO_COMMENTS_QUERY_KEY_PREFIX, applicationId, todoId],
    queryFn: async (): Promise<TodoComment[]> => {
      const response = await profileService.listTodoComments(applicationId.value, todoId.value);
      return (response?.data as TodoCommentListResponse | undefined)?.items ?? [];
    },
    enabled: computed(() => !!applicationId.value && !!todoId.value && hasTodoViewSubmissionPermission.value),
  });

  const comments = computed<TodoComment[]>(() => sortCommentsAscending(data.value ?? []));

  return {
    comments,
    isLoading,
    isError,
  };
};
